var map = {
	"./alert-blue.svg": "./Areas/Responsive/Assets/Images/SVG/alert-blue.svg",
	"./alert-red.svg": "./Areas/Responsive/Assets/Images/SVG/alert-red.svg",
	"./alert-white.svg": "./Areas/Responsive/Assets/Images/SVG/alert-white.svg",
	"./arrow.svg": "./Areas/Responsive/Assets/Images/SVG/arrow.svg",
	"./check_circle_48.svg": "./Areas/Responsive/Assets/Images/SVG/check_circle_48.svg",
	"./checkmark.svg": "./Areas/Responsive/Assets/Images/SVG/checkmark.svg",
	"./chevron-down.svg": "./Areas/Responsive/Assets/Images/SVG/chevron-down.svg",
	"./chevron-left.svg": "./Areas/Responsive/Assets/Images/SVG/chevron-left.svg",
	"./chevron-right-blue.svg": "./Areas/Responsive/Assets/Images/SVG/chevron-right-blue.svg",
	"./chevron-right-green.svg": "./Areas/Responsive/Assets/Images/SVG/chevron-right-green.svg",
	"./chevron-right-lightblue.svg": "./Areas/Responsive/Assets/Images/SVG/chevron-right-lightblue.svg",
	"./chevron-right-white.svg": "./Areas/Responsive/Assets/Images/SVG/chevron-right-white.svg",
	"./chevron-right.svg": "./Areas/Responsive/Assets/Images/SVG/chevron-right.svg",
	"./cut.svg": "./Areas/Responsive/Assets/Images/SVG/cut.svg",
	"./external-page.svg": "./Areas/Responsive/Assets/Images/SVG/external-page.svg",
	"./facebook.svg": "./Areas/Responsive/Assets/Images/SVG/facebook.svg",
	"./facebook_footer.svg": "./Areas/Responsive/Assets/Images/SVG/facebook_footer.svg",
	"./instagram.svg": "./Areas/Responsive/Assets/Images/SVG/instagram.svg",
	"./instagram_footer.svg": "./Areas/Responsive/Assets/Images/SVG/instagram_footer.svg",
	"./linkedin.svg": "./Areas/Responsive/Assets/Images/SVG/linkedin.svg",
	"./linkedin_footer.svg": "./Areas/Responsive/Assets/Images/SVG/linkedin_footer.svg",
	"./lock.svg": "./Areas/Responsive/Assets/Images/SVG/lock.svg",
	"./lock_outline.svg": "./Areas/Responsive/Assets/Images/SVG/lock_outline.svg",
	"./magnifying-glass.svg": "./Areas/Responsive/Assets/Images/SVG/magnifying-glass.svg",
	"./symetra-logo.svg": "./Areas/Responsive/Assets/Images/SVG/symetra-logo.svg",
	"./twitter.svg": "./Areas/Responsive/Assets/Images/SVG/twitter.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./Areas/Responsive/Assets/Images/SVG sync .*\\.svg$";